module.exports = __webpack_public_path__ + "media/images/nabor-24-e70b809462fcd0a32551bb37b2ae9947.jpg";